import SectionHead from "@/components/SectionHead";
import { Search, Globe, ShieldCheck, MessageCircle, ClipboardList, UserCheck, ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";

const ICONS = [Search, Globe, ShieldCheck, MessageCircle, ClipboardList, UserCheck];

const Journey = () => {
  const t = useLang().t;
  const FLOW = ICONS.map((icon, i) => ({ icon, label: t.journey.steps[i] }));
  return (
  <section data-testid="journey" className="bg-[#F5F2EB] py-16 sm:py-24">
    <div className="container-site">
      <SectionHead
        testId="journey-head"
        eyebrow={t.journey.eyebrow}
        title={t.journey.title}
        sub={t.journey.sub}
      />
      <div className="mt-14 flex flex-wrap items-center justify-center gap-y-6" data-testid="journey-flow">
        {FLOW.map((step, i) => (
          <div key={step.label} className="flex items-center">
            <div className="flex flex-col items-center gap-3 px-2 sm:px-4">
              <div
                className={`flex h-16 w-16 sm:h-20 sm:w-20 items-center justify-center rounded-2xl border ${
                  i === FLOW.length - 1
                    ? "border-[#A88667] bg-[#4A362E] text-white shadow-md"
                    : "border-[#EFEBE4] bg-white text-[#A88667] shadow-sm"
                }`}
              >
                <step.icon className="h-7 w-7 sm:h-8 sm:w-8" />
              </div>
              <p className="text-center text-xs sm:text-sm font-semibold text-[#3E2723]">{step.label}</p>
            </div>
            {i < FLOW.length - 1 && <ArrowRight className="h-5 w-5 shrink-0 text-[#D7B594]" />}
          </div>
        ))}
      </div>
    </div>
  </section>
  );
};

export default Journey;
